import { render, staticRenderFns } from "./p20.vue?vue&type=template&id=d05b7e70&scoped=true&"
import script from "./p20.vue?vue&type=script&lang=js&"
export * from "./p20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05b7e70",
  null
  
)

export default component.exports